exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".side-nav>.col-auto{display:none}@media (min-width:992px){.side-nav>.col-auto{display:block}}.side-nav>.tab-content .breadcrumb-anchor{margin-bottom:.5rem;font-family:Balzano,Webdings,inerit;font-weight:500;line-height:1.2;color:inherit;font-size:2.5rem;display:none}@media (max-width:991.98px){.side-nav>.tab-content .breadcrumb-anchor{display:block}.side-nav>.tab-content .tab-pane{display:block!important;opacity:1!important;margin-bottom:1rem}.side-nav>.tab-content .tab-pane:last-child{margin-bottom:0}}.breadcrumb-item.side-nav-breadcrumb-item{display:none}@media (max-width:991.98px){.breadcrumb-item.side-nav-breadcrumb-item{display:unset}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/Components/SideNav.scss
// module id = 84
// module chunks = 0 1 2 3 4 6 10 12